import React from 'react'

const CardBox = (props) => {
    return (
        <div className="card-box btn-block" style={{ marginBottom: 100  }}>
            {props.children}
        </div>
    )
}

export default CardBox;


// WEBPACK FOOTER //
// ./src/components/CardBox.js